import { Autocomplete } from "stimulus-autocomplete"

export default class extends Autocomplete {
  submit() {
    this.hiddenTarget.form.requestSubmit()
  }
}